import React, { useEffect, useState } from 'react';
import { BaseReact } from '../../base.model';
import { ProfileQL } from '../../models/Profile';

import { NavLink } from 'react-router-dom'
import { ReactComponent as Logo } from './logo.svg';

import AccountLinker from '../components/accountLinker';
import ProfileMenu from '../visuals/profilemenu';
import ItemMenu from '../Forms/menu/MenuComponent';
import AccountSwitch from '../components/accountSwitch';
import ConnectAccountsDialog from '../components/connectAccounts.dialog';
import GraphQlClient from '../../services/graphql';
import './Menu.scss';

interface MenuProps extends BaseReact {
    currentUser: ProfileQL;
}

function MenuGeneral({ history, location, currentUser }: MenuProps) {
    const userHasNoFiscalpop = !currentUser.fiscalpopProfile;
    const [menuShow, setMenuShow] = useState(false);
    const [isProfessionalWelcome, setIsProfessionalWelcome] = useState(false)

    const [linkGroup, setLinkGroup] = useState<'facturacion' | ''>('facturacion');

    /*
    const isProfessional = !!currentUser?.professionalProfile?.planType &&
    currentUser?.professionalProfile?.planType !== 'lite';
    */
    useEffect(() => {
        console.log(`<PlanWelcomeDialogProfessional> UE search: `, location.search)
        if (location.search) {
            const search = location.search.replace('?', '').split('&').reduce((p, c) => {
                const [key, value] = c.split('=');
                p[key] = value;
                return p;
            }, {} as { [key: string]: string })

            if (search['welcome'] === 'profesional') {
                setIsProfessionalWelcome(true);
                setLinkGroup(''); // Avoid expanding both
            } else {
                setIsProfessionalWelcome(false);
            }
        } else {
            setIsProfessionalWelcome(false);
        }
    }, [location.search])

    const closeSession = () => {
        setTimeout(() => {
            // Avoid memory leak when menu closes after logout option triggered
            GraphQlClient.logOut();
        }, 450);
    }

    const linkClicked = () => {
        setMenuShow(false);
    }

    const rfcAccount = () => {
        const rfcState = !!currentUser.fiscalpopProfile ? currentUser.fiscalpopProfile.rfc : 'Sin RFC';
        return (
            <div className={`_rfcAccount ${currentUser?.professionalProfile?.linkerId ? 'accounts' : ''}`}>
                <div className='_menuRfcAccount'>
                    <p className="_rfc">
                        {rfcState}
                    </p>
                    <i className="material-icons">expand_more</i>
                </div>
            </div>
        )
    }

    const openLinkGroup = (group: 'facturacion' | '') => () => {
        if (userHasNoFiscalpop) {
            return
        }
        if (group === linkGroup) {
            setLinkGroup('')
        } else {
            setLinkGroup(group)
        }
        // Remove welcome styles
        if (isProfessionalWelcome) {
            setIsProfessionalWelcome(false);
        }
    }

    const renderBillingLinks = () => {
        return (
            <div className="__links">
                <div className={`_link ${userHasNoFiscalpop ? 'disabled' : ''}`} onClick={linkClicked}>
                    <NavLink to={`/setup`} activeClassName="selected">
                        <div className="link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                                <path d="M17 19V17C17 15.9391 16.5786 14.9217 15.8284 14.1716C15.0783 13.4214 14.0609 13 13 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19" fill="#A4A5B2" />
                                <path d="M17 19V17C17 15.9391 16.5786 14.9217 15.8284 14.1716C15.0783 13.4214 14.0609 13 13 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19H17Z" stroke="#A4A5B2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9 9C11.2091 9 13 7.20914 13 5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5C5 7.20914 6.79086 9 9 9Z" fill="#A4A5B2" stroke="#A4A5B2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p>
                                Mi Cuenta
                            </p>
                        </div>
                    </NavLink>
                </div>

                <div className="_space" />
                <div className={`_linkGroup ${linkGroup === 'facturacion' ? '' : 'closed'} ${userHasNoFiscalpop ? 'disabled' : ''}`}>
                    <div className={`_linkGroupTrigger ${linkGroup === 'facturacion' ? 'selected' : ''}`} onClick={openLinkGroup('facturacion')}>
                        <div className="link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="0 0 22 27" fill="none">
                                <path d="M13.375 1.22217H3.475C2.81859 1.22217 2.18906 1.48293 1.72491 1.94708C1.26076 2.41123 1 3.04076 1 3.69717V23.4972C1 24.1536 1.26076 24.7831 1.72491 25.2473C2.18906 25.7114 2.81859 25.9722 3.475 25.9722H18.325C18.9814 25.9722 19.6109 25.7114 20.0751 25.2473C20.5392 24.7831 20.8 24.1536 20.8 23.4972V8.64717L13.375 1.22217Z" fill="#A4A5B2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13.375 1.22217V8.64717H20.8" fill="#A4A5B2" />
                                <path d="M13.375 1.22217V8.64717H20.8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M15.85 12.8848H5.94995" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M15.9 15.8848H6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M16 20.2222H12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M8.44995 9.88477H7.19995H5.94995" fill="#A4A5B2" />
                                <path d="M8.44995 9.88477H7.19995H5.94995" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p>
                                Facturación
                            </p>
                            <span className="material-icons">
                                chevron_right
                            </span>
                        </div>
                    </div>

                    <div className='_linkGroupContainer' style={{ maxHeight: `230px` }}>
                        <div className={`_link ${userHasNoFiscalpop ? 'disabled' : ''}`} onClick={linkClicked}>
                            <NavLink to="/dashboard" activeClassName="selected">
                                <div className="link">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="25" viewBox="0 0 21 25" fill="none">
                                        <path d="M8.10144 0.253662H1.53693C1.08939 0.298988 0.678524 0.507628 0.392409 0.834852C0.106294 1.16208 -0.0322919 1.58184 0.00636132 2.00415V6.50317C-0.0322919 6.92548 0.106294 7.34524 0.392409 7.67247C0.678524 7.99969 1.08939 8.20833 1.53693 8.25366H8.10144C8.54898 8.20833 8.95985 7.99969 9.24596 7.67247C9.53208 7.34524 9.67066 6.92548 9.63201 6.50317V2.00415C9.67066 1.58184 9.53208 1.16208 9.24596 0.834852C8.95985 0.507628 8.54898 0.298988 8.10144 0.253662Z" fill="#A4A5B2" />
                                        <path d="M8.10144 10.2526H1.53693C1.08939 10.2979 0.678524 10.5066 0.392409 10.8338C0.106294 11.161 -0.0322919 11.5808 0.00636132 12.0031V22.5032C-0.0322919 22.9255 0.106294 23.3453 0.392409 23.6725C0.678524 23.9997 1.08939 24.2083 1.53693 24.2537H8.10144C8.54898 24.2083 8.95985 23.9997 9.24596 23.6725C9.53208 23.3453 9.67066 22.9255 9.63201 22.5032V12.0031C9.67066 11.5808 9.53208 11.161 9.24596 10.8338C8.95985 10.5066 8.54898 10.2979 8.10144 10.2526Z" fill="#A4A5B2" />
                                        <path d="M19.4631 16.2523H12.9046C12.457 16.2976 12.0461 16.5062 11.76 16.8335C11.4739 17.1607 11.3353 17.5804 11.374 18.0027V22.5032C11.3353 22.9255 11.4739 23.3452 11.76 23.6725C12.0461 23.9997 12.457 24.2083 12.9046 24.2537H19.4631C19.9106 24.2083 20.3215 23.9997 20.6076 23.6725C20.8937 23.3452 21.0323 22.9255 20.9936 22.5032V18.0027C21.0323 17.5804 20.8937 17.1607 20.6076 16.8335C20.3215 16.5062 19.9106 16.2976 19.4631 16.2523Z" fill="#A4A5B2" />
                                        <path d="M19.4631 0.253662H12.9046C12.457 0.298988 12.0461 0.507628 11.76 0.834852C11.4739 1.16208 11.3353 1.58184 11.374 2.00415V12.5028C11.3353 12.9251 11.4739 13.3449 11.76 13.6721C12.0461 13.9993 12.457 14.208 12.9046 14.2533H19.4631C19.9106 14.208 20.3215 13.9993 20.6076 13.6721C20.8937 13.3449 21.0323 12.9251 20.9936 12.5028V2.00415C21.0323 1.58184 20.8937 1.16208 20.6076 0.834852C20.3215 0.507628 19.9106 0.298988 19.4631 0.253662Z" fill="#A4A5B2" />
                                    </svg>
                                    <p>
                                        Resumen
                                    </p>
                                </div>
                            </NavLink>
                        </div>
                        <div className={`_link ${userHasNoFiscalpop ? 'disabled' : ''}`} onClick={linkClicked}>
                            <NavLink to="/facturacion/facturar" activeClassName="selected">
                                <div className="link">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="0 0 22 27" fill="none">
                                        <path d="M13.375 1.22217H3.475C2.81859 1.22217 2.18906 1.48293 1.72491 1.94708C1.26076 2.41123 1 3.04076 1 3.69717V23.4972C1 24.1536 1.26076 24.7831 1.72491 25.2473C2.18906 25.7114 2.81859 25.9722 3.475 25.9722H18.325C18.9814 25.9722 19.6109 25.7114 20.0751 25.2473C20.5392 24.7831 20.8 24.1536 20.8 23.4972V8.64717L13.375 1.22217Z" fill="#A4A5B2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M13.375 1.22217V8.64717H20.8" fill="#A4A5B2" />
                                        <path d="M13.375 1.22217V8.64717H20.8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M15.85 12.8848H5.94995" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M15.9 15.8848H6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M16 20.2222H12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M8.44995 9.88477H7.19995H5.94995" fill="#A4A5B2" />
                                        <path d="M8.44995 9.88477H7.19995H5.94995" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <p>
                                        Facturar
                                    </p>
                                </div>
                            </NavLink>
                        </div>
                        <div className={`_link ${userHasNoFiscalpop ? 'disabled' : ''}`} onClick={linkClicked}>
                            <NavLink to="/facturacion/setup/pagos" activeClassName="selected">
                                <div className="link">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="28" viewBox="0 0 22 28" fill="none">
                                        <path d="M13.9608 2.57089C13.5857 2.19582 13.077 1.98511 12.5466 1.98511H3.475C2.81859 1.98511 2.18906 2.24587 1.72491 2.71002C1.26076 3.17417 1 3.8037 1 4.46011V24.2601C1 24.9165 1.26076 25.546 1.72491 26.0102C2.18906 26.4743 2.81859 26.7351 3.475 26.7351H18.325C18.9814 26.7351 19.6109 26.4743 20.0751 26.0102C20.5392 25.546 20.8 24.9165 20.8 24.2601V10.2385C20.8 9.7081 20.5893 9.19939 20.2142 8.82432L13.9608 2.57089Z" fill="#A4A5B2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M15.85 13.6477H5.94995" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M15.9 16.6477H6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M16 20.9851H12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M8.44995 10.6477H7.19995H5.94995" fill="#A4A5B2" />
                                        <path d="M8.44995 10.6477H7.19995H5.94995" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M13.375 1.98511V9.41011H20.8" fill="#A4A5B2" />
                                        <path d="M13.375 1.98511V9.41011H20.8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="16" cy="6.20703" r="5" fill="#A4A5B2" stroke="white" strokeWidth="1.5" />
                                        <path d="M18.3145 3.99513H14.6206C14.0683 3.99513 13.6206 4.44284 13.6206 4.99513V5.01713C13.6206 5.56941 14.0683 6.01713 14.6206 6.01713H17.3145C17.8668 6.01713 18.3145 6.46484 18.3145 7.01713V7.29187C18.3145 7.84416 17.8668 8.29187 17.3145 8.29187H13.6206M15.9676 2.98413V9.55562" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <p>

                                        Complementos <br />de pago
                                    </p>
                                </div>
                            </NavLink>
                        </div>
                        <div className={`_link ${userHasNoFiscalpop ? 'disabled' : ''}`} onClick={linkClicked}>
                            <NavLink to="/facturacion/notacredito" activeClassName="selected">
                                <div className="link">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 26 18" fill="none">
                                        <path d="M25.8753 17.652H4.28979V7.27905H26.0001L25.8753 17.652Z" fill="#A4A5B2" />
                                        <path d="M1 13.5031V1.74707H23.3682V13.5031H1Z" fill="#A4A5B2" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                        <ellipse cx="18.6152" cy="7.81535" rx="1.16798" ry="1.2277" fill="white" />
                                        <ellipse cx="22.5628" cy="12.6562" rx="1.16798" ry="1.2277" fill="white" />
                                        <ellipse cx="2.16798" cy="12.6562" rx="1.16798" ry="1.2277" fill="white" />
                                        <ellipse cx="2.16798" cy="2.8798" rx="1.16798" ry="1.2277" fill="white" />
                                        <ellipse cx="22.803" cy="2.8798" rx="1.16798" ry="1.2277" fill="white" />
                                        <ellipse cx="5.45777" cy="7.81535" rx="1.16798" ry="1.2277" fill="white" />
                                        <ellipse cx="12.1156" cy="7.89894" rx="3.87882" ry="4.07717" stroke="white" />
                                        <path d="M13.9112 6.09515H11.0942C10.6389 6.09515 10.2698 6.46425 10.2698 6.91956V6.91956C10.2698 7.37486 10.6389 7.74396 11.0942 7.74396H12.9837C13.4959 7.74396 13.9112 8.15919 13.9112 8.67141V8.67141C13.9112 9.18363 13.4959 9.59886 12.9837 9.59886H10.2698M12.0905 5.27075V10.6294" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <p>
                                        Nota de crédito
                                    </p>
                                </div>
                            </NavLink>
                        </div>
                    </div>
                </div>
                <div className="_space" />
                <div className="_link" onClick={linkClicked}>
                    <NavLink to="/facturas" activeClassName="selected">
                        <div className="link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="30" viewBox="0 0 22 30" fill="none">
                                <path d="M13.5 1H3.5C2.83696 1 2.20107 1.26339 1.73223 1.73223C1.26339 2.20107 1 2.83696 1 3.5V23.5C1 24.163 1.26339 24.7989 1.73223 25.2678C2.20107 25.7366 2.83696 26 3.5 26H18.5C19.163 26 19.7989 25.7366 20.2678 25.2678C20.7366 24.7989 21 24.163 21 23.5V8.5L13.5 1Z" fill="#A4A5B2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13.4998 1V8.5H20.9998" fill="#A4A5B2" />
                                <path d="M13.4998 1V8.5H20.9998" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M16.0007 12.7803H6.00073" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M16.0505 15.8105H6.05054" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M16.152 20.1917H12.1116" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M8.52598 9.75024H7.26336H6.00073" fill="#A4A5B2" />
                                <path d="M8.52598 9.75024H7.26336H6.00073" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M5.79813 27.7674L2.01025 23.9795L5.79813 20.1917" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M11.1014 23.98H2.0105" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M5.79813 27.7674L2.01025 23.9795L5.79813 20.1917" stroke="#A4A5B2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M11.1014 23.98H2.0105" stroke="#A4A5B2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p>
                                Facturas anteriores
                            </p>
                        </div>
                    </NavLink>
                </div>
                <div className="_link" onClick={linkClicked}>
                    <NavLink to="/catalogos" activeClassName="selected">
                        <div className="link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path d="M2 5C2 2.79086 3.79086 1 6 1H19V25H6C3.79086 25 2 23.2091 2 21V5Z" fill="#A4A5B2" />
                                <path d="M19 20H4C2.34315 20 1 21.3431 1 23V23" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                                <path d="M16 9H6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M14 6H12.5H8" fill="#A4A5B2" />
                                <path d="M14 6H12.5H8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M23 6.5L23.5 6.5L23.5 6L23.5 3C23.5 1.61929 22.3807 0.5 21 0.5L20 0.5L19.5 0.5L19.5 1L19.5 6L19.5 6.5L20 6.5L23 6.5Z" fill="#A4A5B2" stroke="white" />
                                <path d="M19.5 12L19.5 12.5L20 12.5L22 12.5C22.8284 12.5 23.5 11.8284 23.5 11L23.5 8C23.5 7.17157 22.8284 6.5 22 6.5L20 6.5L19.5 6.5L19.5 7L19.5 12Z" fill="#A4A5B2" stroke="white" />
                                <path d="M19.5 18L19.5 18.5L20 18.5L21 18.5C22.3807 18.5 23.5 17.3807 23.5 16L23.5 13L23.5 12.5L23 12.5L20 12.5L19.5 12.5L19.5 13L19.5 18Z" fill="#A4A5B2" stroke="white" />
                            </svg>
                            <p>
                                Catálogos
                            </p>
                        </div>
                    </NavLink>
                </div>

            </div>
        )
    }

    return (
        <div id="MenuGeneral" className={`${menuShow ? 'active' : ''}`}>
            <div className="__logoPlaceholder">
                <Logo />
                <AccountLinker currentUser={currentUser} />
            </div>

            <div className="__rfcState">
                <ItemMenu openOrientation={'right'} widthBehaviour={'unset'} triggerContent={rfcAccount()} noPadding={true} overlayRootElement={'MenuGeneral'}>
                    <AccountSwitch currentUser={currentUser} />
                    <div className="_actionsAccount">
                        <ConnectAccountsDialog currentUser={currentUser} />
                        <div className="_act warn" onClick={closeSession}>
                            <p><b>Cerrar sessión</b></p>
                        </div>
                    </div>
                </ItemMenu>
            </div>

            {
                renderBillingLinks()
            }

            <ProfileMenu currentUser={currentUser} />
            <div className="__MenuHidder" onClick={() => setMenuShow(!menuShow)}>
                {
                    menuShow ?
                        <div className="menuCloseOverlay" onClick={() => setMenuShow(false)} />
                        : null
                }
                <div className="_iconHolder">
                    <i className="material-icons">
                        keyboard_arrow_right
                    </i>
                </div>
            </div>
        </div>
    )
}


export default MenuGeneral;